import o from "../../../../hooks/useReactiveState/useReactiveState.js";
import { EMPTY_OBJECT as u } from "../../../../utils/value/constants.js";
const f = (t = u, e) => {
  const {
    canResetState: a,
    defaultState: s,
    resetState: r,
    state: i,
    updateState: l
  } = o(t, e);
  return { canResetFilters: a, defaultFilters: s, filters: i, resetFilters: r, updateFilters: l };
};
export {
  f as default
};
